import { type ComponentPropsWithoutRef, memo } from 'react';

import { type Clip } from '@air/api/types';
import { FileExtensionPreview } from '@air/component-file-extension-preview';
import { cn } from '@air/utils-tailwind';

type AssetGalleryCardProcessingProps = Pick<Clip, 'ext'> & Pick<ComponentPropsWithoutRef<'div'>, 'className'>;

export const AssetGalleryCardProcessing = memo(({ className, ext }: AssetGalleryCardProcessingProps) => {
  return (
    <div
      className={cn(
        'shimmer-background relative flex flex-1 flex-col items-center justify-center bg-grey-4',
        className,
      )}
    >
      <FileExtensionPreview ext={ext} text="Processing" color="gray" size="medium" className="grow justify-center" />
    </div>
  );
});

AssetGalleryCardProcessing.displayName = 'AssetGalleryCardProcessing';
